import React from 'react';

import { Dropbox } from 'dropbox';

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
    };
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.uploadDone = props.uploadDone;
  }
  onFormSubmit(e) {
    e.preventDefault(); // Stop form submit
    this.fileUpload(this.state.file).then((response) => {
      this.uploadDone();
    });
  }
  onChange(e) {
    this.setState({ file: e.target.files[0] });
  }
  fileUpload(file) {
    if (file) {
      var dbx = new Dropbox({ accessToken: 'Y2SJaWmFtwAAAAAAAAAABhL-2SP8bRmwASUCtXvUkkc64zWMuD7oMlj1vdmlJLl6' });
      return dbx.filesUpload({ path: this.props.basePath + file.name, contents: file });
    }
  }

  render() {
    return (
      <form onSubmit={this.onFormSubmit}>
        <div className='row'>
          <div className='col-sm-12'>
            <input type='file' className='' onChange={this.onChange} />
          </div>
          <div className='col-sm-12 mt-2'>
            <button type='submit' className='btn btn-primary' disabled={this.props.basePath.indexOf('undefined') != -1}>
              Importer mon fichier
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/Components/FileUpload.js